import { render, staticRenderFns } from "./DeactiveAccount.vue?vue&type=template&id=71e7fa34"
import script from "./DeactiveAccount.vue?vue&type=script&lang=js"
export * from "./DeactiveAccount.vue?vue&type=script&lang=js"
import style0 from "./DeactiveAccount.vue?vue&type=style&index=0&id=71e7fa34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports